import SearchAutocompleteWrapper from './SearchAutocomplete';

export default SearchAutocompleteWrapper;
